@file:Suppress("EXPERIMENTAL_API_USAGE")

package com.downdogapp.client.api

import com.downdogapp.*
import com.downdogapp.client.MANIFEST
import kotlinx.serialization.encodeToString

/**
 * AUTO-GENERATED DO NOT EDIT!
 * from com.downdogapp.tasks.api.json.requests.ClientRequestsFile
 */
// @formatter:off
abstract class Request {

  abstract val parameterMap: Map<String, String?>
  abstract val url: String
}

class CancelStitchRequest(
  url: String
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "url" to url
  )

  override val url get() = MANIFEST.requestUrls.cancelStitch
}

class ChallengeEnrollRequest(
  dailyEmailNotifications: Boolean,
  dailyPushNotifications: Boolean,
  challengeUpdateEmails: Boolean
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "dailyEmailNotifications" to dailyEmailNotifications.toString(),
    "dailyPushNotifications" to dailyPushNotifications.toString(),
    "challengeUpdateEmails" to challengeUpdateEmails.toString()
  )

  override val url get() = MANIFEST.requestUrls.challengeEnroll
}

class ChangePromotionalEmailStatusRequest(
  subscribe: Boolean
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "subscribe" to subscribe.toString()
  )

  override val url get() = MANIFEST.requestUrls.changePromotionalEmailStatus
}

class DeleteAllHistoryRequest : Request() {

  override val parameterMap = mapOf<String, String?>()

  override val url get() = MANIFEST.requestUrls.deleteAllHistory
}

class DeleteHistoryItemRequest(
  practiceId: String
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "practiceId" to practiceId
  )

  override val url get() = MANIFEST.requestUrls.deleteHistoryItem
}

class DeleteUserRequest : Request() {

  override val parameterMap = mapOf<String, String?>()

  override val url get() = MANIFEST.requestUrls.deleteUser
}

class ForgotPasswordRequest(
  email: String
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "email" to email
  )

  override val url get() = MANIFEST.requestUrls.forgotPassword
}

class HistoryRequest : Request() {

  override val parameterMap = mapOf<String, String?>()

  override val url get() = MANIFEST.requestUrls.history
}

class HistoryDetailsRequest(
  practiceId: String
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "practiceId" to practiceId
  )

  override val url get() = MANIFEST.requestUrls.historyDetails
}

class IssueRefundRequest(
  paymentId: String
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "paymentId" to paymentId
  )

  override val url get() = MANIFEST.requestUrls.issueRefund
}

class LatestPaymentRequest : Request() {

  override val parameterMap = mapOf<String, String?>()

  override val url get() = MANIFEST.requestUrls.latestPayment
}

class LoginRequest(
  email: String? = null,
  password: String? = null,
  facebookIdToken: String? = null,
  googleIdToken: String? = null,
  appleIdToken: String? = null
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "email" to email,
    "password" to password,
    "facebookIdToken" to facebookIdToken,
    "googleIdToken" to googleIdToken,
    "appleIdToken" to appleIdToken
  )

  override val url get() = MANIFEST.requestUrls.login
}

class LogoutRequest : Request() {

  override val parameterMap = mapOf<String, String?>()

  override val url get() = MANIFEST.requestUrls.logout
}

class ManifestRequest(
  oldCred: String? = null,
  signInReason: SignInReason? = null
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "oldCred" to oldCred,
    "signInReason" to signInReason?.toString()
  )

  override val url: String get() = getManifestUrl()
}

class MessageRequest : Request() {

  override val parameterMap = mapOf<String, String?>()

  override val url get() = MANIFEST.requestUrls.message
}

class OfflineUrlRequest(
  sequenceId: String,
  playlistId: String? = null,
  audioBalance: Double,
  includeCountdown: Boolean,
  includeOverlay: Boolean,
  includePoseNames: Boolean,
  includeClosedCaptions: Boolean,
  mirrorVideo: Boolean,
  videoQualityId: Int
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "sequenceId" to sequenceId,
    "playlistId" to playlistId,
    "audioBalance" to audioBalance.toString(),
    "includeCountdown" to includeCountdown.toString(),
    "includeOverlay" to includeOverlay.toString(),
    "includePoseNames" to includePoseNames.toString(),
    "includeClosedCaptions" to includeClosedCaptions.toString(),
    "mirrorVideo" to mirrorVideo.toString(),
    "videoQualityId" to videoQualityId.toString()
  )

  override val url get() = MANIFEST.requestUrls.offlineUrl
}

class PlaybackUrlRequest(
  sequenceId: String,
  playlistId: String? = null,
  videoOffsetTime: Duration,
  audioBalance: Double,
  includeCountdown: Boolean,
  includeOverlay: Boolean,
  includePoseNames: Boolean,
  includeClosedCaptions: Boolean,
  mirrorVideo: Boolean,
  videoQualityId: Int,
  cellularConnection: Boolean,
  chromecast: Boolean,
  airplay: Boolean
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "sequenceId" to sequenceId,
    "playlistId" to playlistId,
    "videoOffsetTime" to videoOffsetTime.seconds.toString(),
    "audioBalance" to audioBalance.toString(),
    "includeCountdown" to includeCountdown.toString(),
    "includeOverlay" to includeOverlay.toString(),
    "includePoseNames" to includePoseNames.toString(),
    "includeClosedCaptions" to includeClosedCaptions.toString(),
    "mirrorVideo" to mirrorVideo.toString(),
    "videoQualityId" to videoQualityId.toString(),
    "cellularConnection" to cellularConnection.toString(),
    "chromecast" to chromecast.toString(),
    "airplay" to airplay.toString()
  )

  override val url get() = MANIFEST.requestUrls.playbackUrl
}

class PlaylistRequest(
  playlistId: String
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "playlistId" to playlistId
  )

  override val url get() = MANIFEST.requestUrls.playlist
}

class PracticeRequest(
  sequenceId: String? = null,
  sequenceToken: String? = null,
  playlistSettings: Map<Int, Int>,
  forOffline: Boolean
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "sequenceId" to sequenceId,
    "sequenceToken" to sequenceToken,
    "playlistSettings" to playlistSettings.let { JSON.encodeToString(it) },
    "forOffline" to forOffline.toString()
  )

  override val url get() = MANIFEST.requestUrls.practice
}

class PurchaseGiftRequest(
  productId: String
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "productId" to productId
  )

  override val url get() = MANIFEST.requestUrls.purchaseGift
}

class PurchaseMembershipRequest(
  period: ProductPeriod,
  currencyCode: String,
  timezoneOffset: Int
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "period" to period.toString(),
    "currencyCode" to currencyCode,
    "timezoneOffset" to timezoneOffset.toString()
  )

  override val url get() = MANIFEST.requestUrls.purchaseMembership
}

class RecordEventRequest(
  name: String,
  properties: Map<String, String?>
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "name" to name,
    "properties" to properties.let { JSON.encodeToString(it) }
  )

  override val url get() = MANIFEST.requestUrls.recordEvent
}

class RecordFeedbackRequest(
  text: String,
  feedbackType: FeedbackType,
  messageId: String? = null,
  sequenceTime: Duration? = null,
  sequenceId: String? = null
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "text" to text,
    "feedbackType" to feedbackType.toString(),
    "messageId" to messageId,
    "sequenceTime" to sequenceTime?.seconds?.toString(),
    "sequenceId" to sequenceId
  )

  override val url get() = MANIFEST.requestUrls.recordFeedback
}

class RecordLinkClickedRequest(
  id: String? = null,
  linkType: LinkType
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "id" to id,
    "linkType" to linkType.toString()
  )

  override val url get() = MANIFEST.requestUrls.recordLinkClicked
}

class RecordPlaylistStartedRequest(
  playlistId: String,
  regenType: RegenType? = null,
  offline: Boolean
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "playlistId" to playlistId,
    "regenType" to regenType?.toString(),
    "offline" to offline.toString()
  )

  override val url get() = MANIFEST.requestUrls.recordPlaylistStarted
}

class RecordPracticeFinishedRequest(
  sequenceId: String,
  offline: Boolean
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "sequenceId" to sequenceId,
    "offline" to offline.toString()
  )

  override val url get() = MANIFEST.requestUrls.recordPracticeFinished
}

class RecordPracticeStartedRequest(
  sequenceId: String,
  sequenceTime: Duration,
  offline: Boolean
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "sequenceId" to sequenceId,
    "sequenceTime" to sequenceTime.seconds.toString(),
    "offline" to offline.toString()
  )

  override val url get() = MANIFEST.requestUrls.recordPracticeStarted
}

class RecordProgressRequest(
  sequenceId: String,
  sequenceStartTime: Duration,
  sequenceEndTime: Duration,
  offline: Boolean
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "sequenceId" to sequenceId,
    "sequenceStartTime" to sequenceStartTime.seconds.toString(),
    "sequenceEndTime" to sequenceEndTime.seconds.toString(),
    "offline" to offline.toString()
  )

  override val url get() = MANIFEST.requestUrls.recordProgress
}

class RecordPurchaseRequest(
  receipt: String? = null,
  token: String? = null,
  productId: String? = null,
  sequenceId: String? = null,
  transactionId: String? = null,
  trial: Boolean
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "receipt" to receipt,
    "token" to token,
    "productId" to productId,
    "sequenceId" to sequenceId,
    "transactionId" to transactionId,
    "trial" to trial.toString()
  )

  override val url get() = MANIFEST.requestUrls.recordPurchase
}

class RecordSongPlayRequest(
  songId: String,
  playlistId: String? = null
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "songId" to songId,
    "playlistId" to playlistId
  )

  override val url get() = MANIFEST.requestUrls.recordSongPlay
}

class RecordSurveyAnswerRequest(
  surveyId: Int,
  answerId: Int
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "surveyId" to surveyId.toString(),
    "answerId" to answerId.toString()
  )

  override val url get() = MANIFEST.requestUrls.recordSurveyAnswer
}

class RecordTeaserOptionSelectedRequest(
  typeId: Int,
  teaserValues: List<Int>,
  finalValue: Int
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "typeId" to typeId.toString(),
    "teaserValues" to teaserValues.joinToString(",") { it.toString() },
    "finalValue" to finalValue.toString()
  )

  override val url get() = MANIFEST.requestUrls.recordTeaserOptionSelected
}

class RedeemGiftRequest(
  code: String
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "code" to code
  )

  override val url get() = MANIFEST.requestUrls.redeemGift
}

class RegenPlaylistRequest(
  sequenceId: String,
  sequenceTime: Duration,
  regenType: RegenType,
  rewindAmount: Duration? = null,
  playlistSettings: Map<Int, Int>
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "sequenceId" to sequenceId,
    "sequenceTime" to sequenceTime.seconds.toString(),
    "regenType" to regenType.toString(),
    "rewindAmount" to rewindAmount?.seconds?.toString(),
    "playlistSettings" to playlistSettings.let { JSON.encodeToString(it) }
  )

  override val url get() = MANIFEST.requestUrls.regenPlaylist
}

class RenameHistorySequenceRequest(
  sequenceId: String,
  name: String
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "sequenceId" to sequenceId,
    "name" to name
  )

  override val url get() = MANIFEST.requestUrls.renameHistorySequence
}

class RestorePurchasesRequest(
  receipt: String? = null
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "receipt" to receipt
  )

  override val url get() = MANIFEST.requestUrls.restorePurchases
}

class SequenceLengthsRequest(
  settings: Map<Int, Int>
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "settings" to settings.let { JSON.encodeToString(it) }
  )

  override val url get() = MANIFEST.requestUrls.sequenceLengths
}

class SetAutoRenewRequest(
  membershipId: String,
  autoRenew: Boolean
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "membershipId" to membershipId,
    "autoRenew" to autoRenew.toString()
  )

  override val url get() = MANIFEST.requestUrls.setAutoRenew
}

class SetSongFeedbackRequest(
  songId: String,
  playlistId: String,
  feedback: SongFeedback
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "songId" to songId,
    "playlistId" to playlistId,
    "feedback" to feedback.toString()
  )

  override val url get() = MANIFEST.requestUrls.setSongFeedback
}

class SignUpRequest(
  email: String? = null,
  password: String? = null,
  facebookIdToken: String? = null,
  googleIdToken: String? = null,
  appleIdToken: String? = null,
  firstName: String? = null,
  lastName: String? = null
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "email" to email,
    "password" to password,
    "facebookIdToken" to facebookIdToken,
    "googleIdToken" to googleIdToken,
    "appleIdToken" to appleIdToken,
    "firstName" to firstName,
    "lastName" to lastName
  )

  override val url get() = MANIFEST.requestUrls.signUp
}

class StitchProgressRequest(
  url: String
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "url" to url
  )

  override val url get() = MANIFEST.requestUrls.stitchProgress
}

class SubmitCodeRequest(
  code: String? = null
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "code" to code
  )

  override val url get() = MANIFEST.requestUrls.submitCode
}

class UnlinkAppleRequest : Request() {

  override val parameterMap = mapOf<String, String?>()

  override val url get() = MANIFEST.requestUrls.unlinkApple
}

class UnlinkFacebookRequest : Request() {

  override val parameterMap = mapOf<String, String?>()

  override val url get() = MANIFEST.requestUrls.unlinkFacebook
}

class UnlinkGoogleRequest : Request() {

  override val parameterMap = mapOf<String, String?>()

  override val url get() = MANIFEST.requestUrls.unlinkGoogle
}

class UpdateEmailRequest(
  email: String
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "email" to email
  )

  override val url get() = MANIFEST.requestUrls.updateEmail
}

class UpdateHistorySequenceFavoritedRequest(
  sequenceId: String,
  favorite: Boolean
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "sequenceId" to sequenceId,
    "favorite" to favorite.toString()
  )

  override val url get() = MANIFEST.requestUrls.updateHistorySequenceFavorited
}

class UpdatePasswordRequest(
  password: String
) : Request() {

  override val parameterMap: Map<String, String?> = mapOf(
    "password" to password
  )

  override val url get() = MANIFEST.requestUrls.updatePassword
}
